module.exports = __webpack_public_path__ + "img/fourday_ps_02.52690af8.jpg";